module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_html.js
// module id = ../node_modules/core-js/modules/_html.js
// module chunks = 1